import { render, staticRenderFns } from "./GroupConsentDetail.vue?vue&type=template&id=687022ea&scoped=true&"
import script from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
export * from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupConsentDetail.vue?vue&type=style&index=0&id=687022ea&prod&lang=css&"
import style1 from "./GroupConsentDetail.vue?vue&type=style&index=1&id=687022ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687022ea",
  null
  
)

export default component.exports